import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19.3371 16.5246C19.7032 16.1585 20.2968 16.1585 20.6629 16.5246L26.2879 22.1496C26.654 22.5157 26.654 23.1093 26.2879 23.4754C25.9218 23.8415 25.3282 23.8415 24.9621 23.4754L20 18.5133L15.0379 23.4754C14.6718 23.8415 14.0782 23.8415 13.7121 23.4754C13.346 23.1093 13.346 22.5157 13.7121 22.1496L19.3371 16.5246Z",
		fill: "#2171C6"
	})
});
export default SvgChevronUp;
